import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const getAllPendingCount = createAsyncThunk(
    "dashboard/getAllPendingCount",
    async ({ search }, { rejectWithValue }) => {
        try {

            const params = {
                ...({ certificate_status: 'Pending' }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificates/count`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllVerifiedCount = createAsyncThunk(
    "dashboard/getAllVerifiedCount",
    async ({ certificate_status, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...({ certificate_status: 'Verified' }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificates/count`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllIssuedCount = createAsyncThunk(
    "dashboard/getAllIssuedCount",
    async ({ certificate_status, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...({ certificate_status: 'Issued' }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificates/count`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllCancelledCount = createAsyncThunk(
    "dashboard/getAllCancelledCount",
    async ({ search }, { rejectWithValue }) => {
        try {

            const params = {
                ...({ certificate_status: 'Cancelled' }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificates/count`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getCertificateGraphCreation = createAsyncThunk(
    "dashboard/getCertificateGraphCreation",
    async ({ certificate_entity_code, course_code, certificate_status }, { rejectWithValue }) => {
        try {
            const params = {
                ...(certificate_entity_code != null && certificate_entity_code != '' && { certificate_entity_code }),
                ...(course_code != null && course_code != '' && { course_code }),
                ...(certificate_status != null && certificate_status != '' && { certificate_status }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificates/graph-of-certificate-creation`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);